module.exports = __webpack_public_path__ + "static/media/my-friend-icon.f9a4e801.svg";